// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__rIvC3","description":"MealItem_description__3vege","price":"MealItem_price__2YQtR"};